import { getGeneralInfo } from '@/store/account/actions';
import { CampaignCreatorState } from '@/store/campaignCreator/types';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

export const usePilotPlanConfig = () => {
    const { t } = useTranslation();
    const { UserName } = useSelector(getGeneralInfo);

    const listsAvailableForSending = [UserName];

    // used in SendTestModal
    const sendToInput = {
        readOnly: true,
        defaultValue: UserName,
        descriptionMessage: t('pilotplan_warning',{accountemail: UserName}),
    };

    //used in campaign creator - for the reducer ovveride, as the component effect take place long before the seting up default campaign.
    const pilotDefaultCampaignOverride: Partial<CampaignCreatorState> = {
        campaign: {
            Targets: {
                ListNames: listsAvailableForSending,
                SegmentNames: [],
            },
        },
        recipientsCount: 1,
    };

    return {
        pilotDefaultCampaignOverride,
        listsAvailableForSending,
        sendToInput,
    };
};
